/** Сколько окон видно одновременно: старые вытесняются новыми. */
export const MAX_NOTICES = 3;

/** Сообщение без действий гаснет само; ошибка висит до закрытия. */
export const INFO_TTL_MS = 6000;

/** С действием («Отменить») времени на решение нужно больше. */
export const INFO_WITH_ACTIONS_TTL_MS = 10000;
